import Vue from 'vue';

// 알림창
import SlimDialog from 'v-slim-dialog';
import 'v-slim-dialog/dist/v-slim-dialog.css';
import '@/assets/css/custom-v-slim-dialog.css';

Vue.use(SlimDialog);

export default {
	methods: {
		showAlert(params) {
			const options = {
				title: params.title || '알림',
				size: params.size || 'sm',
				okLabel: params.okLabel || '예',
				cancelLabel: params.cancelLabel || '아니요',
			};
			return this.$dialogs.alert(params.message, options);
		},
		showConfirm(params) {
			const options = {
				title: params.title || '알림',
				size: params.size || 'sm',
				okLabel: params.okLabel || '예',
				cancelLabel: params.cancelLabel || '아니요',
			};
			return this.$dialogs.confirm(params.message, options);
		},
	},
};
